import { render, staticRenderFns } from "./ScrollTable.vue?vue&type=template&id=4649e869"
import script from "./ScrollTable.vue?vue&type=script&lang=js"
export * from "./ScrollTable.vue?vue&type=script&lang=js"
import style0 from "./ScrollTable.vue?vue&type=style&index=0&id=4649e869&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports